import { render, staticRenderFns } from "./placeBidTime.vue?vue&type=template&id=04180054&scoped=true"
import script from "./placeBidTime.vue?vue&type=script&lang=js"
export * from "./placeBidTime.vue?vue&type=script&lang=js"
import style0 from "./placeBidTime.vue?vue&type=style&index=0&id=04180054&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04180054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04180054')) {
      api.createRecord('04180054', component.options)
    } else {
      api.reload('04180054', component.options)
    }
    module.hot.accept("./placeBidTime.vue?vue&type=template&id=04180054&scoped=true", function () {
      api.rerender('04180054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/auction/placeBid/components/placeBidTime.vue"
export default component.exports